var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"title":"Authorized DNS Server(s)","sub-title":"These DNS Server(s) are authorized for the users of this organization"}},[_c('AddApprovedDns'),_c('ApprovedDnsList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }